export default {
  ALL: 'ALL',
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  ORDERED: 'ORDERED',
  RE_PLAN: 'RE_PLAN',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  ON_HOLD: 'ON_HOLD',
  APPROVED: 'APPROVED',
  IN_PROGRESS: 'IN_PROGRESS',
  STL_FILES_REQUESTED: 'STL_FILES_REQUESTED',
  STL_FILES_UPLOADED: 'STL_FILES_UPLOADED',
  NEED_MORE_INFO: 'NEED_MORE_INFO',
  ARCHIVED: 'ARCHIVED',
} as const
